export default function dtValueIsNull(value: string) {
  try {
    if (!value) return true
    return (value.match(/0/g) ?? []).length === 15
  } catch (error) {
    console.error({ error, value })
    return true
  }
}